import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from '../context/AuthContext';
import PrivateRoute from './PrivateRoute'; 
import LoginForm from "../pages/LoginForm";  
import AdvanceGroupQueryBuilder from "../pages/AdvanceGroupQueryBuilder"; 
import SegmentActivation from "../pages/SegmentActivation";
import Glossary from "../pages/Glossary";

const AppRoutes = () => {
  const { isAuthenticated } = useAuth();

  return (
    <> 
      <Routes>
        <Route path="/login" element={isAuthenticated ? <Navigate to="/dashboard" /> : <LoginForm />} />

        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <AdvanceGroupQueryBuilder />
            </PrivateRoute>
          }
        />
        <Route
          path="/activation"
          element={
            <PrivateRoute>
              <SegmentActivation />
            </PrivateRoute>
          }
        />
        <Route
          path="/glossary"
          element={
            <PrivateRoute>
              <Glossary />
            </PrivateRoute>
          }
        />
 
 

        {/* Fallback Route */}
        <Route path="*" element={<Navigate to="/dashboard" />} />
      </Routes>
    </>
  );
};
export default AppRoutes;